import { observeAnalyticsRequests } from "./analyticsRequests";
import axios from 'axios';

import firebase from './firebase';
import { emulatorPlan } from './emulatorTransport';
import { apiBaseUrl } from 'api/baseUrl';

// An emulator build talks only to its own API (see emulatorTransport.ts): never
// to the shared dev/prod API or the production Cloud Functions.
const EMULATED = emulatorPlan(process.env, window.location.origin).kind !== 'production';

const LOCAL_SERVER_ONLINE = process.env.REACT_APP_API_TARGET === 'local';

const DEVELOPMENT = !document.location.host.includes('gastronaut.ai') && process.env.REACT_APP_API_TARGET !== 'api' // && false;


// Deployed hosts all match the gastronaut.ai host check above, so without this
// override every non-prod deploy (e.g. staging.app.gastronaut.ai) would talk to
// the prod API.
const API_URL_OVERRIDE = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');

const liveServer = API_URL_OVERRIDE || 'https://api.gastronaut.ai';

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'schillingroofbarhd';

const devServer = LOCAL_SERVER_ONLINE ? 'http://localhost:8000' : API_URL_OVERRIDE || 'https://dev.api.gastronaut.ai';

const ownServer = EMULATED ? apiBaseUrl : DEVELOPMENT ? devServer : liveServer;

// The emulator stand runs no Cloud Functions: such calls fail on the own API.
const functionsEndpoint = EMULATED
  ? `${apiBaseUrl}/emulator-has-no-cloud-functions`
  : `https://europe-west3-${projectId}.cloudfunctions.net/apiEndpoint`;

let authReady = null;

// firebase restores the session asynchronously, currentUser stays null until then
const waitForAuth = () => {
  if (!authReady) {
    authReady = new Promise((resolve) => {
      let unsubscribe = null;

      unsubscribe = firebase.auth().onAuthStateChanged(() => {
        resolve();
        if (unsubscribe) unsubscribe();
      });
    });
  }

  return authReady;
};

const currentIdToken = async () => {
  await waitForAuth();

  const user = firebase.auth().currentUser;

  return user ? user.getIdToken() : null;
};

export const idTokenOrNull = async () => {
  try {
    // the axios timeout starts after the interceptor, so cap the token wait here
    return await Promise.race([
      currentIdToken(),
      new Promise((resolve) => setTimeout(() => resolve(null), 5000)),
    ]);
  } catch (e) {
    console.error('ID token unavailable, sending request without it', e?.code);
    return null;
  }
};

// Some v03 routes identify staff by a verified Firebase ID token instead of the
// uid in the body, so send it on every call to our own API.
export const withIdToken = (instance) => {
  instance.interceptors.request.use(async (config) => {
    // voucher and support calls bring their own Authorization, never overwrite it
    const hasAuth =
      config.headers.Authorization ||
      config.headers.authorization ||
      config.headers.common?.Authorization;

    if (hasAuth) return config;

    const token = await idTokenOrNull();

    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  });

  return observeAnalyticsRequests(instance);
};

export default withIdToken(
  axios.create({
    baseURL: ownServer,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const apiendpoint = withIdToken(
  axios.create({
    baseURL: functionsEndpoint,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const googleServer = withIdToken(
  axios.create({
    baseURL: functionsEndpoint,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const mainServer = withIdToken(
  axios.create({
    baseURL: ownServer,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);
